import { homeInspectionRules } from './rules';
export function evaluateHomeInspectionRequirement(input) {
    // if submitting a policy, only evaluate home policies
    if (input.policy && input.policy.policyType !== 'H') {
        return {
            shouldOrderInspection: false,
            reasons: ['Not a home policy'],
            ruleDetails: {}
        };
    }
    const triggeredReasons = [];
    const ruleDetails = {};
    // Evaluate each rule
    for (const rule of homeInspectionRules) {
        const triggered = rule.evaluate(input);
        ruleDetails[rule.name] = {
            triggered,
            value: rule.getValue ? rule.getValue(input) : undefined,
            threshold: rule.getThreshold ? rule.getThreshold() : undefined
        };
        if (triggered) {
            triggeredReasons.push(rule.description);
        }
    }
    const shouldOrderInspection = triggeredReasons.length > 0;
    return {
        shouldOrderInspection,
        reasons: triggeredReasons,
        ruleDetails
    };
}
export function shouldOrderHomeInspection(input) {
    const result = evaluateHomeInspectionRequirement(input);
    return result.shouldOrderInspection;
}
//# sourceMappingURL=evaluator.js.map